<template>
    <div class="pintuan">
        <Header title="" :show-back="true"/>
        <div class="pintuan-pancel">
            <div class="coin-item">
                <h2>拼团获得更多收益</h2>
                <div class="coin-img">
                    <img :src="require(`../../assets/img/pintuan/coin${parseInt(current.index,10)+1}.png`)"/>
                </div>
            </div>
        </div>
        <div class="pintuan-rules">
            <div class="pintuan-rules-container">
                <dl class="title">规则</dl>
                <dl class="text">
                    <p>
                        1.拼团成功收益延长百分之20。<br/>
                        2.拼团需要2人才能拼团成功。<br/>
                        3.邀请好友拼团，邀请奖奖励保留。<br/>
                        4.每期团员成员不能与往期完全相同。
                    </p>
                </dl>
            </div>
        </div>
        <div class="pintuan-operate">
            <div class="title">
                <dl>拼团还差<span class="num">1</span>人</dl>
                <dl class="right" @click="copyEvent" v-if="buy_code" id="copy" :data-clipboard-text="copyText">
                    <span style="margin-right: 10px;">拼团码：{{buy_code}}</span>
                    复制拼团码
                </dl>
            </div>
            <div class="member">
                <dl v-if="uid_1_pic">
                    <img :src="uid_1_pic">
                </dl>
                <dl v-if="uid_2_pic">
                    <img :src="uid_2_pic">
                </dl>
                <!-- <dl class="add">
                   <img src="../../assets/img/pintuan/add.png">
                </dl> -->
            </div>
            <div class="btn">
                <button @click="comfirmBuy('team')">拼团购买</button>
                <button class="comfirm" @click="comfirmBuy('direct')">直接购买</button>
            </div>
        </div>
        <!--密码框-->
        <van-dialog
                v-model="showBuyComifrm"
                title="租用"
                show-cancel-button
                confirm-button-color="#1FC26D"
                @confirm="buyMiner"
                @cancel="cancelEvent"

        >
            <div class="dialog-content">
                <p class="dialog-text">{{current.good_name}}{{current.day}}天<span>限租{{current.limit}}台</span></p>
                <input type="text" placeholder="请输入拼团码(不输入为发起拼团)" class="pwdInput" v-model="buyCodeInput"
                       style="margin-bottom: 10px;" v-if=" this.type==='team'"
                       autocomplete="off"/>
                <input type="password" placeholder="请输入交易密码" class="pwdInput" v-model="pay_password"
                       autocomplete="off"/>
            </div>
        </van-dialog>
    </div>
</template>

<script>
    import Header from "../../components/header";
    import Clipboard from "clipboard";

    export default {
        components: {
            Header
        },
        data() {
            return {
                showBuyComifrm: false,
                pay_password: '',
                buyCodeInput: "",
                current: {},
                buy_code: '',
                uid_1_pic: '',
                uid_2_pic: '',
                copyText: '',
                type: '',
            }
        },
        created() {
            this.current = this.$route.query;
            this.buy_code = this.$route.query.buy_code || '';
            this.getData()
        },
        methods: {
            comfirmBuy(type) {
                this.showBuyComifrm = true;
                this.type = type
            },
            getData() {

                this.ajax.post('appapi/miner/teamBuyInfo', {
                    buy_code: this.buy_code || '',
                    good_id: this.current.good_id
                }).then((res) => {
                    if (res.data.code === 1) {
                        let data = res.data.data;
                        this.buy_code = data.buy_code;
                        this.uid_1_pic = data.uid_1_pic;
                        this.uid_2_pic = data.uid_2_pic;
                        this.copyText = this.buy_code;
                    }
                })
            },
            copyEvent() {
                let clipboard = new Clipboard("#copy");
                clipboard.on("success", e => {
                    this.$toast("已经成功复制");
                    e.clearSelection();
                });
                clipboard.on("error", e => {
                    // 不支持复制
                    this.$toast("暂不支持复制功能");
                    e.clearSelection();
                });
            },
            cancelEvent() {
                this.pay_password = "";
            },
            buyMiner() {
                let url = this.type === 'team' ? 'appapi/miner/teamBuy' : '/appapi/miner/buy';
                let data = {
                    good_id: this.current.good_id,
                    pay_password: this.pay_password,
                    buy_code: this.buyCodeInput
                };

                this.ajax.post(url, data).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg || '购买成功');
                        this.$router.go(0);
                    } else {
                        this.pay_password = "";
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    .pintuan {
        &-pancel {
            width: 100%;
            height: 699px;
            background: url(/img/city_background.png) no-repeat 56% 345px;
            background-size: 160%;

            h2 {
                color: #666666;
                font-weight: 400;
                padding: 97px 0 67px;
                font-size: 72px;
                text-align: center;
                font-weight: bold;
            }

            .coin-item {
                width: 100%;
                background: url('../../assets/img/pintuan/coin_background.png') no-repeat 53px 0;
                background-size: 90%;
                height: 100%;
            }

            .coin-img {
                width: 303px;
                height: 333px;
                margin: 0 auto;

            }
        }

        &-rules {
            padding: 20px 35px 0px 45px;
            width: 100%;

            &-container {
                width: 100%;
                height: 255px;
                box-sizing: border-box;
                background: url('../../assets/img/pintuan/rules_background.png') no-repeat 0 0;
                background-size: cover;
                padding: 50px 60px 0;
                color: #fff;
                @include flex();

                .title {
                    font-size: 60px;
                    font-weight: bold;
                    width: 53px;
                }

                .text {
                    // width:390px;
                    margin-left: 57px;
                    font-size: 24px;
                    line-height: 40px;
                }
            }

            // margin: 10px 45px 0 35px;

        }

        &-operate {
            width: 100%;
            height: 508px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px -15px 18px 0px rgba(179, 179, 179, 0.3);
            border-radius: 20px;
            padding: 0 35px;

            .title {
                @include flex($main: space-between);
                color: #666666;
                font-size: 24px;
                height: 80px;
                line-height: 80px;
                border-bottom: 1Px solid #F4F3F3;

                .num {
                    color: #FF5B5B;
                }

                .right {
                    color: #1FC26D;
                }
            }

            .member {
                padding: 56px 0;
                @include flex();

                dl {
                    width: 109px;
                    height: 110px;
                    border-radius: 50%;
                    margin-right: 28px;

                    &.add {
                        border: 3PX solid #ededed;
                        background-color: #fff;
                        box-sizing: border-box;
                    }
                }
            }

            .btn {
                @include flex($main: space-around);

                button {
                    width: 301px;
                    height: 82px;
                    border: 1Px solid rgba(31, 194, 109, 1);
                    border-radius: 10px;
                    color: #1FC26D;
                    font-size: 24px;
                    text-align: center;
                    line-height: 82px;
                    box-sizing: border-box;

                    &.comfirm {
                        background: #1FC26D;
                        color: #fff;
                    }
                }
            }
        }

        .van-dialog__header {
            text-align: left;
            padding-left: 42px;
        }

        .dialog {
            &-content {
                padding: 30px 42px;

                .pwdInput {
                    display: block;
                    width: 100%;
                    height: 78px;
                    background: rgba(249, 249, 249, 1);
                    border-radius: 4px;
                    padding: 20px 30px;
                    box-sizing: border-box;
                }
            }

            &-text {
                font-size: 30px;

                font-weight: 500;
                color: rgba(116, 126, 137, 1);
                line-height: 42px;
                margin-bottom: 25px;

                span {
                    color: #14B94E;
                    font-size: 22px;
                    margin-left: 30px;
                }
            }
        }

    }
</style>
